import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "showOwnerNames",
  pure: true,
  standalone: true,
})
export class ShowOwnerNamesPipe implements PipeTransform {
  transform(owners: any[]): string {
    if (!owners || owners.length === 0) {
      return "";
    }

    const ownerNames = owners.map(({ full_name }) =>
      full_name !== null ? full_name : "",
    );
    const lastOwner = ownerNames.pop();
    if (ownerNames.length === 0) {
      return lastOwner;
    } else {
      return ownerNames.join(", ") + " and " + lastOwner;
    }
  }
}
